export default __webpack_public_path__ + "static/media/profile-edit.e2d73583.svg";